export default __webpack_public_path__ + "static/academia-vista-3333fc61ccfe78947600833f202cfdcb.jpg";